import React, { useState } from "react";
import { Form, Input, Button, Checkbox, Typography, message, Dropdown } from "antd";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  GoogleOutlined,
  GlobalOutlined,
  CheckCircleOutlined,
  MailOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Login.css";
import icon from "../assets/img/kapinsightsLogo.png";
import { useDispatch } from "react-redux";
import { setUser } from "../hooks/userSlice";
import axios from "axios";
import { ToastContainer } from "../components/CustomToast/index";
import { Spin } from "antd";
import { post } from "../utils/apiUtils";
import KapInsigntsLogo from "../assets/img/kapininsightsLogo.png";
import GeneralButton from "../components/GeneralButton/index";

const Login: React.FC = () => {
  const { t, i18n } = useTranslation("auth");
  const { t: tCommon } = useTranslation("common");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Loading state

  // Language selector handler
  const handleLanguageChange = (e: { key: string }) => {
    i18n.changeLanguage(e.key);
    localStorage.setItem("i18nextLng", e.key);
  };

  const onFinish = async (values: any) => {
    console.log("Received values of form: ", values);
    setLoading(true); // Start loading

    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    // If you have client_id and client_secret you can append them here
    // formData.append('client_id', 'your_client_id');
    // formData.append('client_secret', 'your_client_secret');

    try {
      const response = await post<any>("Users/token", formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      if (response.type === "success") {
        const token = response.data.access_token;
        localStorage.setItem("token", token);
        localStorage.setItem("organizationId", response?.data.organization_id);
        localStorage.setItem("refreshToken", response?.data.refresh_token);
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("isAuthenticates", "true");

        if (rememberMe) {
          localStorage.setItem("rememberMe", "true");
          // localStorage.setItem("rememberMe_username", values.email);
          // localStorage.setItem("rememberMe_password", values.password);
        } else {
          localStorage.removeItem("rememberMe");

          // localStorage.removeItem("rememberMe_username");
          // localStorage.removeItem("rememberMe_password");
        }
        // Dispatch the setUser action with the user data

        dispatch(setUser(response.data.user));
        setTimeout(() => toast.success(t("login.loginSuccess")), 0);

        // Navigate to the dashboard or home page
        setTimeout(() => {
          setLoading(false);
          if (
            response.data?.roles[0].role_id !== 1 &&
            response.data?.roles[0].role_id !== 2 &&
            response.data?.roles[0].role_id !== 7
          ) {
            navigate("/workspaces");
            return;
          }
          navigate("/workspaces");
        }, 1500);
      } else {
        message.error(t("login.loginFailed"));
        setLoading(false);
      }
    } catch (error) {
      // If there's an error, you can show it to the users
      toast.error(t("login.loginFailedGeneric"));
      setLoading(false);
    }
  };

  const signInGoogle = async () => {};
  // const handleRememberMe = (val: any) => {
  //   console.log("val:", val.target.checked);
  //   if (val.target.checked) {
  //     localStorage.setItem("rememberMe", "true");
  //     setRememberMe(true);
  //   } else {
  //     // localStorage.setItem("rememberMe", "false");
  //     setRememberMe(false);
  //     setUsername("");
  //     setPassword("");
  //   }
  // };

  // Get current language for menu selection
  const currentLanguage = i18n.language.split("-")[0];
  const languageMenuItems = {
    items: [
      { key: "en", label: tCommon("languages.en") },
      { key: "ar", label: tCommon("languages.ar") },
    ],
    selectedKeys: [currentLanguage],
    onClick: handleLanguageChange,
  };

  return (
    <section className="sign-in">
      <div className="image-icon">
        <div className="marketing-content">
          <h2 className="marketing-heading">From data to decisions, faster.</h2>
          <p className="marketing-subtitle">
            KAPinsights helps you collect, analyse and turn data into trusted insights.
          </p>
          <div className="benefits-row">
            <div className="benefit-item">
              <CheckCircleOutlined className="benefit-icon" />
              <span>Trusted indicators</span>
            </div>
            <div className="benefit-item">
              <CheckCircleOutlined className="benefit-icon" />
              <span>Smarter decisions</span>
            </div>
            <div className="benefit-item">
              <CheckCircleOutlined className="benefit-icon" />
              <span>Real impact</span>
            </div>
          </div>
        </div>
      </div>
      <div className="sign-in-form-container">
        {loading ? (
          <Spin size="large" />
        ) : (
          <>
            <div className="login-header">
              <img
                src={KapInsigntsLogo}
                alt="kapinisghts"
                className="kapinsights-logo"
                // style={{
                //   width: "150px",
                //   height: "37px",
                //   marginLeft: "45rem",
                //   marginTop: "1rem",
                // }}
              />
              <Dropdown menu={languageMenuItems} trigger={["click"]}>
                <button
                  className="login-language-btn"
                  title={tCommon("language")}
                  aria-label={tCommon("language")}
                >
                  <GlobalOutlined />
                  <span>{currentLanguage.toUpperCase()}</span>
                </button>
              </Dropdown>
            </div>
            <Form
              form={form}
              name="normal_login"
              className="sign-in-form"
              initialValues={{
                remember: rememberMe,
                username: username,
                password: password,
              }}
              onFinish={onFinish}
            >
              <h3 className="welcome-back">{t("login.welcomeBack")}</h3>
              <p className="sign-in-text">Sign in to continue to KAPinsights</p>
              <Typography
                className="typography"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {t("login.email")}
              </Typography>
              <Form.Item
                name="username"
                rules={[
                  { required: true, message: t("login.emailRequired") },
                ]}
              >
                <Input
                  prefix={<MailOutlined />}
                  style={{ height: "56px" }}
                  placeholder={t("login.emailPlaceholder")}
                  onChange={(e) => setUsername(e.target.value)}
                  className="emailInput"
                />
              </Form.Item>
              <Typography
                className="typography"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {t("login.password")}
              </Typography>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: t("login.passwordRequired") },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder={t("login.passwordPlaceholder")}
                  iconRender={(visible) =>
                    visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                  }
                  style={{ height: "56px" }}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Item>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Form.Item
                  name="remember"
                  valuePropName="checked"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Checkbox
                    checked={rememberMe}
                    // onChange={() => setRememberMe(!rememberMe)}
                    onChange={(val) => setRememberMe(val.target.checked)}
                    style={{ color: "gray" }}
                  >
                    {t("login.rememberMe")}
                  </Checkbox>
                </Form.Item>
                <Form.Item>
                  <a
                    className="forgot-password"
                    href="/forgot-password"
                    style={{ color: "#A072EB" }}
                  >
                    {t("login.forgotPassword")}
                  </a>
                </Form.Item>
              </div>

              <Form.Item>
                <GeneralButton
                  htmlType="submit"
                  className="login-form-button-style"
                  loading={loading}
                  block
                >
                  {t("login.signInButton")}
                </GeneralButton>
              </Form.Item>
              <p className="do-not-account">
                {t("login.noAccount")} &#160;
                <a href="/signup" type="button" className="sign-upp">
                  {t("login.signUp")}
                </a>
              </p>
            </Form>
          </>
        )}
        <div></div>
      </div>
    </section>
  );
};

export default Login;
